<template>
  <div class="articleContent">
    <div class="title">
      <span class="title-sty">信息查询服务</span>
    </div>
    <div>
      <el-card
        shadow="never"
        class="home-article-card office-card"
        style="min-height: 350px"
      >
        <information-inquiry
          :typeList="informationInquiryList"
        ></information-inquiry>
      </el-card>
    </div>
    <div class="title">
      <span class="title-sty">文物地图服务</span>
    </div>
    <div class="announcement">
      <div class="frame">
        <el-button @click="unit()" :type="unitMap"
          >全国重点文物保护单位地图</el-button
        >
        <el-button @click="heritage()" :type="heritageMap"
          >革命文物地图</el-button
        >
        <el-button @click="red()" :type="redMap">红色旅游路线</el-button>
      </div>

      <el-row style="height: 10px"></el-row>
      <div style="height: 500px">
        <div style="height: 100%">
          <iframe
            width="100%"
            height="100%"
            frameborder="0"
            :src="Url"
          ></iframe>
        </div>
      </div>
    </div>
    <quick-entry-svg :dataList="exhibition"></quick-entry-svg>
    <div class="title">
      <span class="title-sty">彩塑壁画数字化展示</span>
    </div>
    <div class="announcement">
      <el-row>
        <el-col :span="24" class="el-col-temple">
          <el-button class="temple">平遥双林寺</el-button>
        </el-col>
        <el-col :span="24" class="el-col-templee">
          <a href="http://gl.ncha.gov.cn:9099/source/welcome/" target="_blank"
            ><span class="colTem"></span
          ></a>
        </el-col>
      </el-row>
      <ul>
        <li @click="Showdetails(1, '渡海观音悬塑墙三维模型')">
          <span class="sls slsOn"></span>
          <div class="caption">
            <h4>渡海观音悬塑墙三维模型</h4>
            <p>
              渡海观音彩塑位于释迦殿倒座影壁墙北侧。观音两手抱左膝曲起、右肩微微前探，正由一片莲瓣托举着从汹涌的波涛中显身而出，身后飘带随风翻飞，在十大圆觉像的簇拥下，更突出造像灵动飘逸和端庄秀美的气质。
            </p>
          </div>
        </li>
        <li @click="Showdetails(1, '韦陀彩塑三维模型')">
          <span class="sls slsTw"></span>
          <div class="caption">
            <h4>韦陀彩塑三维模型</h4>
            <p>
              韦陀胁侍彩塑位于千佛殿明间，神情衣饰细致生动，以左腿着力、头颈带动胸腹上身向右侧反向扭转，呈现出夸张的“S”造型，巧妙模拟人体动态。同时两臂括挺、衣带当风，体现出刚中带柔、亦静亦动、威而不悍的气势，被业内专家学者誉为“全国韦陀之冠”。
            </p>
          </div>
        </li>
        <li @click="Showdetails(2, '精细化病害勘察记录', img.img1)">
          <span class="sls slsTh"></span>
          <div class="caption">
            <h4>精细化病害勘察记录</h4>
            <p>
              通过细致的现场调研和系统的病害勘察记录，结合正射光/侧射光数字化高清影像、三维模型以及红外热波等无损检测技术，绘制精细化病害图，对彩塑壁画文物本体的病害展开量化分析，明确主要问题和活动性病害，并对整体保存状况进行科学的评估。
            </p>
          </div>
        </li>
        <li @click="Showdetails(1, '千手观音彩塑三维模型')">
          <span class="sls slsFo"></span>
          <div class="caption">
            <h4>千手观音彩塑三维模型</h4>
            <p>
              千手观音彩塑为菩萨殿主尊，面容丰腴、姿态优雅，26只手臂从身躯两侧层叠伸出，或持法器珍宝、或做各式手印，塑造细致而不烦琐。各手臂通
              过高低位置和曲折角度的不同，营造出协调统一、张弛有度之感，是明代彩塑的杰出作品之一。
            </p>
          </div>
        </li>
        <li @click="Showdetails(2, '光环境勘察', img.img2)">
          <span class="sls slsFi"></span>
          <div class="caption">
            <h4>光环境勘察</h4>
            <p>
              现场调研过程中，发现双林寺彩塑壁画褪色变色现象明显。而彩绘层中的胶结物质和某些颜料/染料可能对光照十分敏感。因此在项目中开展了对彩塑壁画的光环境进行勘察研究，发现太阳直射光和天空漫反射光照射时间长、照度高，直接影响前檐壁画的保存；而殿内彩塑的褪色程度与采光系数强度存在较明显的对应关系。
            </p>
          </div>
        </li>
        <li @click="Showdetails(1, '佛传故事悬塑三维模型')">
          <span class="sls slsSi"></span>
          <div class="caption">
            <h4>佛传故事悬塑三维模型</h4>
            <p>
              释迦殿内四壁运用圆雕、深/浅浮雕手法，采取分层组合、连环壁塑形式，表现了佛教创始人释迦牟尼从投胎降生到涅槃成佛以及四方传经普渡众生
              的佛传故事。二百多尊人物形象身份不同，神态各异，活动于建筑、山石之间，构思构图绝妙，令人叹为观止，颇富有我国民间艺术的传统特色。
            </p>
          </div>
        </li>
        <li @click="Showdetails(2, '结构性病害致因分析', img.img3)">
          <span class="sls slsSe"></span>
          <div class="caption">
            <h4>结构性病害致因分析</h4>
            <p>
              在文物建筑三维激光扫描点云模型基础上，提取出高程信息绘制相对高程彩虹图，结合现场勘察发现的贯穿性裂缝、壁画三维形变、悬塑墙支撑木
              骨架变形脱离等结构性病害，对病害的致因展开深入分析。
            </p>
          </div>
        </li>
        <li @click="Showdetails(2, '壁画虚拟清晰化', img.img4)">
          <span class="sls slsEi"></span>
          <div class="caption">
            <h4>壁画虚拟清晰化</h4>
            <p>
              双林寺现存壁画集中于千佛殿、菩萨殿前檐外壁，历经四百余年风吹日晒多数已斑驳不清，画面内容难以辨识。工作组在高清正射影像基础上，经过一系列计算机图像处理，提高了画面清晰度和色彩效果，使对壁画的欣赏和解读成为可能。
            </p>
          </div>
        </li>
      </ul>
    </div>
    <el-dialog
      :title="title"
      :class="State == 1 ? 'dialog_0' : 'dialog_1'"
      :visible.sync="centerDialogVisible"
      @close="videoClose"
      center
    >
      <div v-if="State == 1">
        <video v-if="videoFlag" width="100%" height="100%" controls>
          <source :src="VideoUrl" type="video/mp4" />
          您的浏览器不支持 video 标签。
        </video>
      </div>
      <div v-if="State == 2">
        <img style="width: 100%; height: 100%" :src="imgUrl" />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { exhibition } from "../../utils/staticDict";
import util from "../../utils/util";

export default {
  props: [],
  components: {
    "information-inquiry": () =>
      import("@/components/Home/InformationInquiry/InformationInquiry.vue"),
    "quick-entry-svg": () => import("@/components/Home/QuickEntrySvg.vue"),
  },
  data() {
    return {
      Url: "http://dtdj.cchicc.org.cn/#/stateprotect",
      // 静态数据
      informationInquiryList: [],
      exhibition: exhibition,
      // 全国重点文物保护单位地图
      unitMap: "danger",
      // 革命文物地图
      heritageMap: "success",
      // 红色旅游路线
      redMap: "success",
      State: 1,
      videoFlag: false,
      centerDialogVisible: false,
      title: null,
      imgUrl: null,
      VideoUrl: null,
      img: {
        img1: require("../../assets/3.jpg"),
        img2: require("../../assets/5.jpg"),
        img3: require("../../assets/7.jpg"),
        img4: require("../../assets/10.gif"),
      },
    };
  },
  computed: {},
  methods: {
    Showdetails(number, title, url) {
      this.videoFlag = false;
      this.$nextTick(() => {
        this.videoFlag = true;
      });
      this.title = `${title}`;
      let Url = util.getAjaxUrl("axiosFour");
      if (number == 1) {
        this.State = 1;
        this.VideoUrl = `${Url}/api/print/getVideo?name=${title}`;
      } else if (number == 2) {
        this.State = 2;
        this.imgUrl = `${url}`;
      }

      this.centerDialogVisible = true;
    },
    videoClose() {
      this.VideoUrl = "";
    },
    unit() {
      this.unitMap = "danger";
      this.heritageMap = "success";
      this.redMap = "success";
      // this.Url = "http://202.41.241.235/#/stateprotect";
      this.Url = "http://dtdj.cchicc.org.cn/#/stateprotect";
    },
    heritage() {
      this.unitMap = "success";
      this.heritageMap = "danger";
      this.redMap = "success";
      // this.Url = "http://202.41.241.235/#/redheritage";
      this.Url = "http://dtdj.cchicc.org.cn/#/redheritage";
    },
    red() {
      this.unitMap = "success";
      this.heritageMap = "success";
      this.redMap = "danger";
      // this.Url = "http://202.41.241.235/#/heritageroute";
      this.Url = "http://dtdj.cchicc.org.cn/#/heritageroute";
    },
    async getInformationInquiryList() {
      let ajaxUrl = util.getAjaxUrl("axiosThree");
      let params = {
        modletype: "公共服务",
      };
      const res = await this.$http
          .post(ajaxUrl + `/api/queryProtalServiceConfigList`, params)
      if (res.data.code == 200) {
        let InformationInquiryListObject = {};
        let InformationInquiryListObject1 = {};
        res.data.data.data[0].children.forEach((element) => {
          InformationInquiryListObject = {
            label: "",
            value: [],
          };
          InformationInquiryListObject.label = element.name;
          InformationInquiryListObject.id = element.id;
          let id = 1;
          element.children.forEach((el) => {
            InformationInquiryListObject1 = {};
            InformationInquiryListObject1.title = el.name;
            InformationInquiryListObject1.icon_class = el.icon;
            InformationInquiryListObject1.only = el.noly;
            InformationInquiryListObject1.url = el.url;
            InformationInquiryListObject1.path = el.path;
            InformationInquiryListObject1.id = id;
            id++;
            if (el.name == "中国历史文化名城名单") {
              InformationInquiryListObject1.type = "cityName";
            }
            if (el.name == "中国历史文化名镇名单") {
              InformationInquiryListObject1.type = "townName";
            }
            if (el.name == "中国历史文化名村名单") {
              InformationInquiryListObject1.type = "villageName";
            }
            if (el.name == "中国历史文化街区名单") {
              InformationInquiryListObject1.type = "streetName";
            }
            if (el.flag == 1) {
              InformationInquiryListObject.value.push(
                  InformationInquiryListObject1
              );
            }
          });
          if (element.flag == 1) {
            this.informationInquiryList.push(InformationInquiryListObject);
          }
        });
        console.log(
            "this.informationInquiryList",
            this.informationInquiryList
        );
      }
    },
  },
  created() {
    this.getInformationInquiryList()
  },
};
</script>
<style scoped lang='less'>
@import "../../styles/base";
@import "../../styles/comSty";
.title {
  margin-top: 0;
}
#sub-frame-error {
  -webkit-align-items: center;
  background-color: #ddd;
  display: -webkit-flex;
  -webkit-flex-flow: column;
  height: 100%;
  -webkit-justify-content: center;
  left: 0;
  // position: absolute;
  text-align: center;
  top: 0;
  transition: background-color 0.2s ease-in-out;
  width: 100%;
}

.temple {
  background-color: #b71c1c;
  border-color: #b71c1c;
  color: #fff;
}
.el-col-temple {
  text-align: center;
  margin-bottom: 10px;
  padding: 0 20px;
}
.el-col-templee {
  width: 100%;
  height: 200px;
  text-align: center;
  margin-bottom: 10px;
  padding: 0 20px;
}
.colTem {
  display: inline-block;
  width: 100%;
  height: 100%;
  background: url(../../assets/ceshi.jpg) repeat 50%;
  background-size: cover;
  border-radius: 5px;
  cursor: pointer;
  background-position: -290px;
}
ul {
  padding: 0 20px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
li {
  border-radius: 8px;
  // height: 420px;
  border: 1px solid rgb(176, 176, 176);
  font-weight: bolder;
  width: 24%;
  margin-bottom: 10px;
}
.caption {
  padding: 20px;
  color: #616a79;
  cursor: pointer;
  > h4 {
    margin: 0;
    font-size: 18px;
  }
  > p {
    font-size: 13px;
    text-align: left;
    font-weight: 500;
  }
}
.sls {
  display: block;
  width: 100%;
  max-width: 100%;
  height: 200px;
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;
}
.slsOn {
  background: url(../../assets/swmx.png);
  background-size: 100%;
}
.slsTw {
  background: url(../../assets/sls2.png);
  background-size: 120%;
}
.slsTh {
  background: url(../../assets/sls3.png);
  background-size: 100%;
}
.slsFo {
  background: url(../../assets/sls4.png);
  background-size: 100%;
}
.slsFi {
  background: url(../../assets/sls5.png);
  background-size: 110%;
}
.slsSi {
  background: url(../../assets/sls6.png);
  background-size: 100%;
}
.slsSe {
  background: url(../../assets/sls7.png);
  background-size: 100%;
}
.slsEi {
  background: url(../../assets/sls9.png);
  background-size: 110%;
}
</style>
